<template>
	<div>
		tu ide analitka
	</div>
</template>

<script>

export default {
	data() {
		return {
		};
	},
	methods:{

	},

	watch: {

	},
	
	mounted(){
		//paginacija
		this.$store.state.paginacija.title = "Statistika i analize"
		
	}
}

</script>